export default __webpack_public_path__ + "static/media/close.3f65b7ef.svg";